import { render, staticRenderFns } from "./DosBoxWindowsLink.vue?vue&type=template&id=9839feb8&"
import script from "./DosBoxWindowsLink.vue?vue&type=script&lang=js&"
export * from "./DosBoxWindowsLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports